// extracted by mini-css-extract-plugin
module.exports = {"Image":"NotFound_Image__JQErT","ImageContainer":"NotFound_ImageContainer__QgBzS","Button":"NotFound_Button__1w__5"};